import { Component, OnInit, ViewChild, AfterViewInit, Output, EventEmitter, ElementRef } from '@angular/core';
import { PasswordGenModel } from './PasswordGen.model';
import { TextBoxComponent } from '../../../text-box/text-box.component';
import { ButtonComponent } from '../../../button/button.component';
import { FormComponent } from '../../../form/form.component';
import { ServiceStock } from '../../../service-stock.service';
import { HttpResponse } from '@angular/common/http';
import { RadioButtonComponent } from '../../../radio-button/radio-button.component';

const customCss: string = '';

@Component({
selector: 'app-PasswordGen',
templateUrl: './PasswordGen.component.html'
})
export class PasswordGenComponent extends FormComponent implements OnInit, AfterViewInit {
@ViewChild('FieldId_1', { static: false }) FieldId_1: ElementRef;
@ViewChild('txtUserID', { static: false }) txtUserID: TextBoxComponent;
@ViewChild('txtBoID', { static: false }) txtBoID: TextBoxComponent;
@ViewChild('txtDOB', { static: false }) txtDOB: TextBoxComponent;
@ViewChild('txtEmail', { static: false }) txtEmail: TextBoxComponent;
@ViewChild('rdbtnpassword', { static: false }) rdbtnpassword: RadioButtonComponent;
@ViewChild('btnSubmit', { static: false }) btnSubmit: ButtonComponent;
@ViewChild('btnCancel', { static: false }) btnCancel: ButtonComponent;
@Output() passGenPageLink = new EventEmitter<String>();
skeletonContentLoaded = false;
async revalidate(): Promise<number> {
var totalErrors = 0;
super.beforeRevalidate();
await Promise.all([
this.revalidateBasicField('txtUserID'),
this.revalidateBasicField('txtBoID'),
this.revalidateBasicField('txtDOB'),
this.revalidateBasicField('txtEmail'),
this.revalidateBasicField('rdbtnpassword'),
]).then((errorCounts) => {
errorCounts.forEach((errorCount) => {
totalErrors += errorCount;
});
});
this.errors = totalErrors;
super.afterRevalidate();
return totalErrors;
}
constructor(services: ServiceStock) {
super(services);
this.value = new PasswordGenModel();
this.componentCode = 'PasswordGen';
}
setReadOnly(readOnly) {
super.setBasicFieldsReadOnly(readOnly);
}
async onFormLoad() {
this.setInputs(this.services.dataStore.getData(this.services.routing.currModal));
this.setDependencies();
}
setInputs(param: any) {
let params = this.services.http.mapToJson(param);
if (params['mode']) {
this.mode = params['mode'];
}
}
async submitForm(path, apiCode, serviceCode) {
this.submitData['formName'] = 'PasswordGen';
await super.submit(path, apiCode, serviceCode);
}
getFieldInfo() {
this.amountComponent.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
this.comboFields.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
// this.fileUploadFields.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
return this.additionalInfo;
}
getFieldValue() {
return this.value;
}
setValue(inputValue, inputDesc = undefined) {
this.setBasicFieldsValue(inputValue, inputDesc);
this.value = new PasswordGenModel();
this.value.setValue(inputValue);
this.setDependencies();
this.passNewValue(this.value);
}
ngOnInit() {
if (this.formCode == undefined) { this.formCode = 'PasswordGen'; }
if (this.formOnLoadError) { return; }
setTimeout(() => {
this.skeletonContentLoaded = true;
}, 1000);
var styleElement = document.createElement('style');
styleElement.type = 'text/css';
//styleElement.innerHTML = customCss;//commented by Shanmuga Priya - VAPT
// Safe: sanitized CSS, using textContent instead of innerHTML (no DOM XSS risk)
//const safeCSS = this.sanitizeCSS(customCss);
styleElement.textContent = customCss;
styleElement.id = 'PasswordGen_customCss';
document.getElementsByTagName('head')[0].appendChild(styleElement);
}
ngOnDestroy() {
this.unsubscribe$.next();
this.unsubscribe$.complete();
var styleElement = document.getElementById('PasswordGen_customCss');
styleElement.parentNode.removeChild(styleElement);
}
ngAfterViewInit() {
setTimeout(() => {
this.subsBFldsValueUpdates();
this.onFormLoad();
this.checkForHTabOverFlow();
});
}
clearError() {
super.clearBasicFieldsError();
super.clearHTabErrors();
super.clearVTabErrors();
this.errors = 0;
this.errorMessage = [];
}
onReset() {
super.resetBasicFields();
this.clearHTabErrors();
this.clearVTabErrors();
this.errors = 0;
this.errorMessage = [];
this.additionalInfo = undefined;
this.dependencyMap.clear();
this.value = new PasswordGenModel();
this.passNewValue(this.value);
this.setReadOnly(false);
this.onFormLoad();
}
async btnSubmit_click() {
let inputMap = new Map();
var errorCount: number = await this.revalidate();
document.getElementById('errMsgDiv').innerHTML = "";
if (errorCount == 0) {
inputMap.clear();
inputMap.set('Body.clientID', this.txtUserID.getFieldValue());
inputMap.set('Body.boID', this.txtBoID.getFieldValue());
inputMap.set('Body.dateOfBirth', this.txtDOB.getFieldValue());
inputMap.set('Body.emailId', this.txtEmail.getFieldValue());
inputMap.set('Body.actionType', this.rdbtnpassword.getFieldValue());
this.services.http.fetchApi('/auth/generatepwd', 'POST', inputMap).subscribe(
async (httpResponse: HttpResponse<any>) => {
var res = httpResponse.body;
var respCode: any = res['respCode'];
if (respCode != null && respCode == 0) {
document.getElementById('errMsgDiv').innerHTML = this.transalte('PasswordGen.Success');
setTimeout(() => {
document.getElementById('errMsgDiv').innerHTML = this.transalte('PasswordGen.Redirect');
}, 2000);
setTimeout(() => {
this.passGenPageLink.emit("loginForm");
}, 4000);
} else {
//document.getElementById('errMsgDiv').innerHTML = res['errMsg'];
//commented by Shanmuga Priya - VAPT
const rawMsg = res['errMsg'];
const plainMsg = rawMsg.replace(/<[^>]*>/g, ""); // remove HTML tags
(document.getElementById('errMsgDiv') as HTMLElement).textContent = plainMsg;
}
},
async (httpError) => {
var err = httpError['error']
if (err != null && err['ErrorElementPath'] != undefined && err['ErrorDescription'] != undefined) {
if (err['ErrorElementPath'] == 'actionType') {
this.rdbtnpassword.setError(err['ErrorDescription']);
}
else if (err['ErrorElementPath'] == 'emailId') {
this.txtEmail.setError(err['ErrorDescription']);
}
else if (err['ErrorElementPath'] == 'dateOfBirth') {
this.txtDOB.setError(err['ErrorDescription']);
}
else if (err['ErrorElementPath'] == 'boID') {
this.txtBoID.setError(err['ErrorDescription']);
}
else if (err['ErrorElementPath'] == 'clientID') {
this.txtUserID.setError(err['ErrorDescription']);
}
}
// this.services.alert.showAlert(2, "failed", -1);
document.getElementById('errMsgDiv').innerHTML =this.transalte('ErrorCodes.SystemDown');
}
);
}
}
async btnCancel_click() {
this.passGenPageLink.emit("loginForm");
}

onKeydown(event) {
if (event.keyCode === 69 || event.keyCode === 38 || event.keyCode === 40 ||
event.keyCode === 187 || event.keyCode === 189 || event.keyCode === 190) {
return false;
}
}
transalte(text) {
    return this.services.translate.instant(text);
  }
fieldDependencies = {
}

}

